/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FcSportsMode } from '@react-icons/all-files/fc/FcSportsMode';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/MainProvider';
import styles from './featured-match.module.scss';

const FeaturedMatch = ({ type, item, context, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  const isInCards = context === 'cards';
  const hasTeamFlag = type === 'soccer' || type === 'handball';

  return (
    <div className={`${styles.container} ${styles[context]} ${styles[type]}`}>
      <div className={styles.teamNames}>
        <span>{item?.home_team?.name}</span>
        {!hasTeamFlag && <span>VS</span>}
        <span>{item?.away_team?.name}</span>
      </div>
      <div className={styles.teamLogos}>
        {hasTeamFlag && (
          <div className={styles.teams}>
            <LazyImage
              alt={item?.home_team?.name}
              src={item?.home_team?.logo}
              width={70}
              height={70}
              defaultImg={<FcSportsMode size={70} />}
            />
            <span>VS</span>
            <LazyImage
              alt={item?.away_team?.name}
              src={item?.away_team?.logo}
              width={70}
              height={70}
              defaultImg={<FcSportsMode size={70} className={styles.secondIcon} />}
            />
          </div>
        )}
        <img
          alt={`${type} field`}
          src={isStorybook ? `./${type}-field.png` : `../../../../../../images/${type}-field.png`}
          className={styles.field}
          width={310}
          height={77}
        />
        {isInCards && (
          <span className={styles.date}>
            {`${item?.date?.day_number}. `}
            <span className={styles.month}>{item?.date?.month_short}</span>
            {` ${item?.date?.year_number} `}
            <span className={styles.at}>{translate(translations, 'at', 'at')}</span>
            {` ${item?.date?.time}`}
          </span>
        )}
      </div>
    </div>
  );
};

export default FeaturedMatch;

FeaturedMatch.propTypes = {
  type: PropTypes.oneOf(['soccer', 'tennis', 'handball']).isRequired,
  item: PropTypes.shape({
    home_team: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
    away_team: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
    date: PropTypes.shape({
      day_number: PropTypes.number,
      month_short: PropTypes.string,
      year_number: PropTypes.number,
      time: PropTypes.string,
    }),
  }).isRequired,
  context: PropTypes.oneOf(['header', 'cards']),
  isStorybook: PropTypes.bool,
};
